import { RootState } from "store/store";

export const getURLParamDefaultPosition = (state: RootState) =>
  state.gridEventSlice.urlParamGridPosition;
